export const GATEWAY = 'gateway';
export const CONTROLLER = 'controller';
export const SENSOR = 'sensor';
export const MESSAGE = 'message';
